import React, { useEffect, useState } from "react";
import "../css/quickShare.scss";
import { PixelWithEvent } from "./common/PixelWithEvent ";
import { sendMessage } from "../apis/SendMessageAPI";
import { BASE_URL } from "../constans/ApiEndpointConstants";
import LocalStorageUtil from "../utils/localStorageUtil";
import Cookies from "js-cookie";
import { getFullDonationUrl } from "../utils/urlUtils";

const QuickShareModal = ({ isOpen, onClose, campaignUrl, detailsData }) => {
  const [copied, setCopied] = useState(false);
  const [shareCount, setShareCount] = useState(0); //分享次数
  const [progress, setProgress] = useState(0);
  const [returnMsg, setReturnMsg] = useState("");
  const [msgHidden, setMsgHidden] = useState(true);
  const share_id = detailsData.id;

  //event_id，要去重，一天之内用一个，存cookie
  const getEventId = (eventType) => {
    // 根据事件类型使用不同的cookie名
    const cookieName = `fb_event_id_${eventType}`;

    let storedEventId = Cookies.get(cookieName);
    if (storedEventId) {
      return storedEventId;
    } else {
      // 使用 10 位随机数字作为 event_id
      const newEventId = Math.round(Math.random() * 10000000000).toString();
      Cookies.set(cookieName, newEventId, { expires: 1 }); // 存储1天
      return newEventId;
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  //处理进度条
  useEffect(() => {
    const savedCount = localStorage.getItem("shareCount");
    const savedProgress = localStorage.getItem("progress");

    if (savedCount) {
      setShareCount(parseInt(savedCount, 10));
    }

    if (savedProgress) {
      const parsedProgress = parseInt(savedProgress, 10);
      setProgress(parsedProgress);

      // 如果 progress 已经是 100，则自动显示第三条 returnMsg
      if (parsedProgress === 100) {
        setReturnMsg(
          "Thank you for sharing! Your support helps this campaign reach more people and make an impact."
        );
        setMsgHidden(false);
      }
    }
  }, []);

  // 锁定背景滚动
  useEffect(() => {
    if (!isOpen) return;

    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleCopyLink = () => {
    const urlWithAd = campaignUrl.includes("?")
      ? `${campaignUrl}&ad=share`
      : `${campaignUrl}?ad=share`;
    navigator.clipboard.writeText(urlWithAd);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  // 分享文案：优先使用 detailsData.share_text（如果存在），否则回退到默认文案
  const defaultShareText =
    "Hello! I’d like to share an important cause that is currently accepting support. Donations of any amount help move this effort forward, and sharing this message is another great way to help. Thank you for your time and consideration.";

  const invitationTextRaw = detailsData.share_text || defaultShareText;

  // 将常见的智能引号替换为普通引号，避免 URL 编码后显示异常
  const invitationText = invitationTextRaw
    .replace(/’/g, "'") // 替换右单引号
    .replace(/‘/g, "'") // 替换左单引号
    .replace(/“/g, '"') // 替换左双引号
    .replace(/”/g, '"'); // 替换右双引号
  // Ensure shared link always points to donationDetails path.
  const safeBase = campaignUrl
    ? campaignUrl.replace(/\/$/, "")
    : window.location.origin;
  const baseShareUrl = detailsData
    ? getFullDonationUrl(detailsData, safeBase)
    : campaignUrl
    ? safeBase
    : `${BASE_URL.replace(/\/$/, "")}/donationDetails/${detailsData?.id || ""}`;
  const campaignUrlWithAd = baseShareUrl.includes("?")
    ? `${baseShareUrl}&ad=share`
    : `${baseShareUrl}?ad=share`;
  const encodedCampaignUrl = encodeURIComponent(campaignUrlWithAd);
  const encodedInvitation = encodeURIComponent(
    `${invitationText}\n${campaignUrlWithAd}`
  );

  // System email fallback
  const emailSubject = encodeURIComponent("Join me in supporting this cause");
  const emailMailtoUrl = `mailto:?subject=${emailSubject}&body=${encodedInvitation}`;
  // Gmail
  const emailGmailComposeUrl = `https://mail.google.com/mail/?view=cm&fs=1&su=${emailSubject}&body=${encodedInvitation}`;

  // Outlook
  const emailOutlookUrl = `https://outlook.live.com/mail/deeplink/compose?subject=${emailSubject}&body=${encodedInvitation}`;

  // Yahoo
  const emailYahooUrl = `https://compose.mail.yahoo.com/?subject=${emailSubject}&body=${encodedInvitation}`;

  const shareOptions = [
    {
      id: "facebook",
      name: "Facebook",
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
        </svg>
      ),
      color: "#1877F2",
      url: `https://www.facebook.com/dialog/share?app_id=407682420960&display=popup&href=${encodedCampaignUrl}`,
    },
    {
      id: "whatsapp",
      name: "WhatsApp",
      icon: (
        <svg
          t="1763977259813"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="44607"
          width="200"
          height="200"
        >
          <path
            d="M512 1024C229.10781 1024-0.121905 794.819048 0 511.951238 0 229.180952 229.10781 0 512 0c282.770286 0 512 229.180952 512 511.951238C1024 794.794667 794.770286 1024 512 1024zM202.825143 827.367619l160.134095-41.203809a311.369143 311.369143 0 0 0 152.429714 39.740952c171.885714 0 311.734857-139.849143 311.734858-311.734857S687.299048 202.459429 515.413333 202.459429c-171.910095 0-311.759238 139.824762-311.759238 311.710476 0 55.832381 14.799238 110.177524 42.910476 157.939809L202.849524 827.367619z m168.326095-97.913905l-92.525714 23.79581 25.185524-89.404953-6.436572-9.99619a257.901714 257.901714 0 0 1-40.862476-139.678476c0-142.726095 116.126476-258.82819 258.876952-258.828191 142.726095 0 258.852571 116.102095 258.852572 258.828191S658.115048 773.022476 515.413333 773.022476c-47.664762 0-94.232381-13.04381-134.704762-37.741714l-9.508571-5.851429z m56.661333-360.350476l-20.23619-1.121524a24.454095 24.454095 0 0 0-17.383619 5.948953c-9.825524 8.533333-25.502476 24.990476-30.305524 46.445714-7.192381 31.98781 3.900952 71.143619 32.646095 110.323809 28.720762 39.15581 82.261333 101.839238 176.932572 128.609524 30.47619 8.606476 54.491429 2.80381 73.020952-9.020952a65.29219 65.29219 0 0 0 28.40381-41.472l3.242666-15.09181a10.48381 10.48381 0 0 0-5.851428-11.702857l-68.388572-31.50019a10.48381 10.48381 0 0 0-12.678095 3.096381l-26.843428 34.791619a7.68 7.68 0 0 1-8.630858 2.584381c-18.383238-6.460952-79.969524-32.256-113.737142-97.328762a7.753143 7.753143 0 0 1 0.975238-8.630857l25.648762-29.671619a10.48381 10.48381 0 0 0 1.706666-10.971429l-29.476571-68.949333a10.48381 10.48381 0 0 0-9.045334-6.339048z"
            fill="#15D135"
            p-id="44608"
          ></path>
        </svg>
      ),
      color: "#25D366",
      url: `https://api.whatsapp.com/send?text=${encodedInvitation}`,
    },

    {
      id: "email",
      name: "Email",
      icon: <img alt="" src={process.env.PUBLIC_URL + "/share/email.png"} />,
      color: "#424242",
      url: emailGmailComposeUrl,
      // ✔ 桌面端优先 Gmail（Chrome）
      // ✔ iPhone Safari 不允许 Gmail → 自动 fallback 到 系统邮件
      // ✔ Android 既能打开 Gmail App，也能 fallback
      onClick: () => {
        const tryOpen = (url) =>
          window.open(url, "_blank", "noopener,noreferrer");

        // 1️⃣ Gmail
        if (tryOpen(emailGmailComposeUrl)) return;

        // 2️⃣ Outlook
        if (tryOpen(emailOutlookUrl)) return;

        // 3️⃣ YahooMail
        if (tryOpen(emailYahooUrl)) return;

        // 4️⃣ 系统 mailto
        window.location.href = emailMailtoUrl;
      },
      sameTab: false,
    },
    {
      id: "sms",
      name: "Sms",
      icon: (
        <svg viewBox="0 0 1024 1024" p-id={2744} width={60} height={60}>
          <path
            d="M761.984 1009.28H253.696C138.368 1009.28 44.8 915.712 44.8 800.384V292.096C44.8 176.768 138.368 83.2 253.696 83.2h508.288c115.328 0 208.896 93.568 208.896 208.896v508.288c0 115.328-93.568 208.896-208.896 208.896z"
            fill="#00E560"
            p-id={2745}
          />
          <path
            d="M507.776 265.856c-72.576 0-139.776 20.352-193.536 54.528-54.272 34.432-94.592 83.2-113.408 139.264-7.552 22.528-11.648 46.464-11.648 71.04 0 92.16 56.448 172.928 142.208 220.544 7.68 4.224 11.648 13.44 8.32 21.632-6.4 15.616-14.592 30.592-24.32 44.672-3.072 4.352 0.768 10.368 6.016 8.96 29.44-7.808 56.96-19.072 81.92-33.28 9.088-5.248 19.456-6.912 29.696-4.864 23.936 4.736 49.024 7.296 74.88 7.296 176 0 318.592-118.656 318.592-264.832 0-146.304-142.72-264.96-318.72-264.96z"
            fill="#FFFFFF"
            p-id={2746}
          />
        </svg>
      ),
      color: "#00E560",
      url: `sms:?body=${encodedInvitation}`,
      sameTab: true,
    },
    {
      id: "line",
      name: "Line",
      icon: (
        <svg
          t="1763973161718"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="16409"
          width="200"
          height="200"
        >
          <path
            d="M512 1024C229.2224 1024 0 794.7776 0 512 0 229.2224 229.2224 0 512 0c282.7776 0 512 229.2224 512 512 0 282.7776-229.2224 512-512 512z m-137.762133-286.378667V397.380267h-102.4V737.621333h102.4z m-51.2-488.448c-33.024 0-54.5792 22.954667-53.9136 53.589334-0.682667 29.218133 20.8896 52.872533 53.248 52.872533 33.672533 0 55.2448-23.6544 55.2448-52.8896-0.682667-30.6176-21.572267-53.572267-54.5792-53.572267z m133.410133 488.448h102.4V541.405867c0-9.728 1.365333-20.1728 4.061867-26.453334 6.724267-19.456 23.569067-39.645867 51.882666-39.645866 37.034667 0 51.882667 29.917867 51.882667 73.762133V737.621333h102.4V535.842133c0-100.181333-50.517333-146.1248-117.9136-146.1248-54.562133 0-88.251733 32.7168-101.7344 54.272h-2.030933l-4.7104-46.609066h-88.9344c1.348267 29.917867 2.696533 66.0992 2.696533 108.544V737.621333z"
            fill="#0073B1"
            p-id="16410"
          ></path>
        </svg>
      ),
      color: "#00C300",
      url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedCampaignUrl}`,
    },
    {
      id: "telegram",
      name: "Telegram",
      icon: (
        <img
          src={process.env.PUBLIC_URL + "/share/telegram.png"}
          alt="Telegram"
          width={60}
          height={60}
          loading="lazy"
        />
      ),
      color: "#0088cc",
      url: `https://telegram.me/share/url?url=${encodedCampaignUrl}&text=${encodeURIComponent(
        invitationText
      )}`,
    },

    {
      id: "x",
      name: "X",
      icon: (
        <svg
          t="1763974179807"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="32571"
          width="200"
          height="200"
        >
          <path
            d="M0 512a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z"
            fill="#000000"
            p-id="32572"
          ></path>
          <path
            d="M196.923077 196.923077m0 0l630.153846 0q0 0 0 0l0 630.153846q0 0 0 0l-630.153846 0q0 0 0 0l0-630.153846q0 0 0 0Z"
            fill="#FFFFFF"
            p-id="32573"
          ></path>
          <path
            d="M518.065231 461.981538L357.966769 237.883077H272.541538l198.340924 277.504 24.969846 34.894769 169.747692 237.764923h85.425231l-208.108308-291.209846-24.851692-34.894769z"
            fill="#000000"
            p-id="32574"
          ></path>
          <path
            d="M806.636308 177.230769H252.494769c-40.014769 0-75.264-0.630154-75.264 39.384616v630.153846c0 40.014769 117.523692 0 157.538462 0l304.64 25.993846c40.054154 0 207.36 14.020923 207.36-25.993846v-630.153846c0-40.014769-0.118154-39.384615-40.132923-39.384616zM639.409231 827.076923l-171.795693-244.696615L252.455385 827.076923H196.923077l246.035692-279.827692L196.923077 196.923077h187.667692l162.658462 231.660308L751.064615 196.923077h55.571693l-234.614154 266.870154L827.076923 827.076923h-187.667692z"
            fill="#000000"
            p-id="32575"
          ></path>
        </svg>
      ),
      color: "#000000",
      url: `https://twitter.com/intent/post?text=${encodedInvitation}&url=${encodedCampaignUrl}`,
    },
    {
      id: "nextdoor",
      name: "Nextdoor",
      icon: (
        <img
          alt=""
          src={process.env.PUBLIC_URL + "/share/nextdoor.png"}
          style={{ borderRadius: "50%" }}
        />
      ),
      color: "#7AD000",
      url: `https://nextdoor.com/share/?url=${encodedCampaignUrl}`,
    },
  ];

  const handleShareOptionClick = (option) => {
    if (!option.url) {
      return;
    }

    // 传递平台名称给 handleShareClick
    handleShareClick(option.name);

    if (typeof option.onClick === "function") {
      option.onClick();
      return;
    }

    if (option.sameTab) {
      window.location.href = option.url;
      return;
    }

    window.open(option.url, option.target || "_blank", "noopener,noreferrer");
  };

  // 处理分享操作
  const handleShareClick = (platform) => {
    // 构建包含平台信息的事件名称
    const eventName = `Click Share - ${platform}`;

    const event_id = getEventId(eventName);

    // 调用 PixelWithEvent，传递包含平台信息的事件名称和 eventParams
    PixelWithEvent(eventName, event_id);

    // 获取 ad 和 userid 并发送消息，包含平台信息
    const storedAd = LocalStorageUtil.getAd();
    const ad = storedAd ?? "donation";
    const userid = localStorage.getItem("userid");
    const message = `${BASE_URL} [Click Share - ${platform}]:id=${share_id}:ad=${ad}:userid=${userid}`;
    sendMessage(message);

    let newShareCount = shareCount + 1;
    let newProgress = progress;

    if (newShareCount !== 3 && newShareCount !== 5) {
      newProgress = Math.min(newProgress + 20, 100);
    }

    setShareCount(newShareCount);
    setProgress(newProgress);

    //将分享次数和进度条进度存在本地缓存
    localStorage.setItem("shareCount", newShareCount);

    // 延迟更新进度条
    setTimeout(() => {
      setProgress(newProgress);
      localStorage.setItem("progress", newProgress);
    }, 800); // 800ms 延迟更新进度条

    setMsgHidden(false);

    // 延迟显示不同的消息
    setTimeout(() => {
      if (newShareCount === 3) {
        setReturnMsg(
          "Share with another friend. Sharing with the same friend doesn't generate statistics."
        );
      } else if (newShareCount === 5) {
        setReturnMsg("Group conversations can also be shared.");
      } else if (newShareCount >= 7) {
        setReturnMsg(
          "Thank you for sharing! Your continued support helps this campaign reach more people and make a lasting impact."
        );
      } else {
        setReturnMsg("");
      }
    }, 800); // 800ms 延迟显示消息
  };

  return (
    <div className="quick-share-modal__overlay" onClick={onClose}>
      <div className="quick-share-modal" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="quick-share-modal__header">
          <h2 className="quick-share-modal__title">Quick share</h2>
          <button
            className="quick-share-modal__close"
            type="button"
            onClick={onClose}
            aria-label="Close modal"
          >
            ×
          </button>
        </div>

        {/* Unique Link Section */}
        <div className="quick-share-modal__link-section">
          <div className="quick-share-modal__link-section-content">
            <label className="quick-share-modal__link-label">
              Your unique link
            </label>
            <div className="quick-share-modal__link-input-wrapper">
              <div className="quick-share-modal__link-input-container">
                <input
                  type="text"
                  className="quick-share-modal__link-input"
                  value={campaignUrlWithAd}
                  readOnly
                />
              </div>
              <div className="quick-share-modal__link-divider"></div>
              <button
                className="quick-share-modal__copy-button"
                type="button"
                onClick={handleCopyLink}
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  width="16"
                  height="16"
                  className="quick-share-modal__copy-icon"
                >
                  <path
                    d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <rect
                    x="8"
                    y="2"
                    width="8"
                    height="4"
                    rx="1"
                    ry="1"
                    strokeWidth="2"
                  />
                </svg>
                {copied ? "Copied!" : "Copy link"}
              </button>
            </div>
          </div>
        </div>

        {/* Reach More Donors Section */}
        <div className="quick-share-modal__share-section">
          <h3 className="quick-share-modal__share-title">
            Reach more donors by sharing
          </h3>
          <p className="quick-share-modal__share-description">
            We've written tailored messages and auto-generated posters based on
            the fundraiser story for you to share
          </p>
          <div className="quick-share-modal__share-grid">
            {shareOptions.map((option) => (
              <button
                key={option.id}
                className="quick-share-modal__share-option"
                type="button"
                onClick={() => handleShareOptionClick(option)}
                aria-label={`Share via ${option.name}`}
              >
                <span
                  className="quick-share-modal__share-icon"
                  style={{ color: option.color }}
                >
                  {option.icon}
                </span>
                <span className="quick-share-modal__share-name">
                  {option.name}
                </span>
              </button>
            ))}
          </div>
          <div className="quick-share-modal__progress-section">
            <div className="quick-share-modal__progress-header">
              <span>Share progress</span>
              <span>{progress}%</span>
            </div>
            {progress > 0 && (
              <div className="quick-share-modal__progress-bar">
                <div
                  className="quick-share-modal__progress-fill"
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
            )}
            <p className="quick-share-modal__share-count">
              Shared {shareCount} times
            </p>
            {!msgHidden && returnMsg && (
              <p className="quick-share-modal__return-msg">{returnMsg}</p>
            )}
          </div>
        </div>

        {/* Shareable Graphics Section */}
        {/* <div className="quick-share-modal__graphics-section">
          <div className="quick-share-modal__graphics-header">
            <div className="quick-share-modal__graphics-icon-wrapper">
              <svg
                t="1763534247650"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="34112"
                width="200"
                height="200"
              >
                <path
                  d="M886.016 128h-752q-30.016 0-51.008 21.504T62.016 200v626.016q0 28.992 20.992 50.496t51.008 21.504h752q30.016 0 51.008-21.504t20.992-50.496V200q0-30.016-20.992-51.008T886.016 128z m0 698.016h-752v-212.992l186.016-190.016 216.992 270.016q8.992 10.016 22.496 11.488t24.512-5.504l160.992-108.992 140.992 67.008v168.992z m0-260L768 518.016q-20.992-16-42.016-2.016l-156 104.992-222.016-275.008q-10.016-12-26.016-12t-27.008 11.008l-160.992 164.992V199.968h752v366.016zM696 274.016q-42.016 0-71.488 29.504t-29.504 71.488 29.504 71.488 71.488 29.504 71.488-29.504 29.504-71.488-29.504-71.488-71.488-29.504z m0 129.984q-12 0-20.512-8.512t-8.512-20.512 8.512-20.512 20.512-8.512 20.512 8.512 8.512 20.512-8.512 20.512-20.512 8.512z"
                  p-id="34113"
                ></path>
              </svg>
            </div>
            <span className="quick-share-modal__graphics-label">
              Shareable graphics
            </span>
          </div>
          <p className="quick-share-modal__graphics-description">
            Download videos to use for posting on social media
          </p>
          <button className="quick-share-modal__download-button" type="button">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              width="16"
              height="16"
              className="quick-share-modal__download-icon"
            >
              <path
                d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <polyline
                points="7 10 12 15 17 10"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <line
                x1="12"
                y1="15"
                x2="12"
                y2="3"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Download
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default QuickShareModal;
